'use strict';

const _IDV_KEY = key => {
	const { user } = window;
	return (user && user.bid && user.id) ? `${user.bid}-${user.id}:${key}` : key;
};
const _context = key => {
	if (window.context) return `${window.context}:${key}`;
	return key;
};
const _get = (storage, key, individual = true) => {
	if (!storage) return null;
	try {
		return JSON.parse(storage.getItem(_context(individual ? _IDV_KEY(key) : key)));
	}
	catch (err) { return null; }
};
const _set = (storage, key, data, individual = true) => {
	if(!storage) return false;
	storage.setItem(_context(individual ? _IDV_KEY(key) : key), JSON.stringify(data));
};
const _remove = (storage, key, individual = true) => {
	if(!storage) return false;
	storage.removeItem(_context(individual ? _IDV_KEY(key) : key));
};
const _removeByPrefix = (storage, prefix, individual) => {
	if(!storage) return false;
	const removes = [];
	_.times(storage.length, i => {
		const key = storage.key(i);
		if(_.startsWith(key, _context(individual ? _IDV_KEY(prefix) : prefix))) removes.push(key);
	});
	return _.map(removes, key => storage.removeItem(key));
};


const SessionStorage = {};
const ss = window.sessionStorage;
SessionStorage.get = _get.bind(null, ss);
SessionStorage.set = _set.bind(null, ss);
SessionStorage.remove = _remove.bind(null, ss);
SessionStorage.removeByPrefix = _removeByPrefix.bind(null, ss);

const ssCallbackQueue = {};
SessionStorage.smartGet = (key, url, onSuccess, options, individual = true) => {
	//key = individual ? _IDV_KEY(key) : key;
	const hasOnRequest = options && (typeof options.onRequest === 'function');
	const hasOnSuccess = typeof onSuccess === 'function';
	let cache = SessionStorage.get(key);
	if (cache !== null && cache !== undefined && hasOnSuccess) onSuccess(cache, true);
	else {
		if (ssCallbackQueue[key]) {
			if (hasOnRequest) options.onRequest();
			if (hasOnSuccess) ssCallbackQueue[key].push(onSuccess);
		} else {
			ssCallbackQueue[key] = [onSuccess];
			new Ajax({
				url: url,
				method: 'get',
				onRequest: hasOnRequest ? options.onRequest : null,
				onSuccess: (code, msg, data, xhr) => {
					SessionStorage.set(key, data);
					const cbQueue = ssCallbackQueue[key];
					for (let i = 0, j = cbQueue.length - 1; i <= j; i++) {
						cbQueue[i](i === j ? data : _.cloneDeep(data), false);
					}
					delete ssCallbackQueue[key];
				},
			}).send();
		}
	}
};

const LocalStorage = {};
const ls = window.localStorage;
LocalStorage.get = _get.bind(null, ls);
LocalStorage.set = _set.bind(null, ls);
LocalStorage.remove = _remove.bind(null, ls);
LocalStorage.removeByPrefix = _removeByPrefix.bind(null, ls);

const lsCallbackQueue = {};
LocalStorage.smartGet = (key, url, onSuccess, options, individual = true) => {
	//key = individual ? _IDV_KEY(key) : key;
	const hasOnRequest = options && (typeof options.onRequest === 'function');
	const hasOnSuccess = typeof onSuccess === 'function';
	let cache = LocalStorage.get(key);
	if (cache && onSuccess && hasOnSuccess) onSuccess(cache);
	else {
		if (lsCallbackQueue[key]) {
			if (hasOnRequest) options.onRequest();
			if (hasOnSuccess) lsCallbackQueue[key].push(onSuccess);
		} else {
			lsCallbackQueue[key] = [onSuccess];
			new Ajax({
				url: url,
				method: 'get',
				onRequest: hasOnRequest ? options.onRequest : null,
				onSuccess: (code, msg, data, xhr) => {
					LocalStorage.set(key, data);
					const cbQueue = lsCallbackQueue[key];
					for (let i = 0, j = cbQueue.length - 1; i <= j; i++) {
						cbQueue[i](i === j ? data : _.cloneDeep(data));
					}
					delete lsCallbackQueue[key];
				},
			}).send();
		}
	}
};

export { SessionStorage, LocalStorage };
